import http from '../http-common'
import { APIBaseFunctions, APIDataSliceObj, defaultAPILimit } from '@/components/Utility/APIBase'

class TeamsDataService extends APIBaseFunctions {
  private cachedTeamsDataSliceObj: APIDataSliceObj = {
    slicemode: 0,
    start: 0,
    limit: defaultAPILimit,
    page: 0,
    pagesize: 0,
    totalcount: 0
  }

  getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    const currentDataSliceObj = TeamsDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTeamsDataSliceObj }, dataSliceObj)

    if (sortingOrder.length > 0) {
      return http.get(`/holds?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    return http.get(`/holds?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
  }

  async asyncGetAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    const currentDataSliceObj = TeamsDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedTeamsDataSliceObj }, dataSliceObj)

    if (sortingOrder.length > 0) {
      return http.get(`/holds?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    return http.get(`/holds?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
  }

  get (id: string) {
    return http.get(`/holds/${id}`)
  }

  async asyncGet (id: string) {
    return http.get(`/holds/${id}`)
  }

  getCount (countParameter = '') {
    return http.get('/holds/count' + (countParameter.length > 0 ? `?${countParameter}` : ''))
  }

  create (data: any) {
    return http.post('/holds', data)
  }

  update (id: string, data: any) {
    return http.put(`/holds/${id}`, data)
  }

  delete (id: string) {
    return http.delete(`/holds/${id}`)
  }

  deleteAll () {
    return http.delete('/holds')
  }

  removeSelectedTeamEmail (data: any) {
    return http.post('/autoEmail', data)
  }
}

export default new TeamsDataService()
